import axios from 'axios';
import { getEnvSettings } from '../../../../../config/environmentSettings';
export const getOperationSettings = (params) => {
    return axios.get('/operation_settings', {
        params: {
            limit: 1000,
            client_code: params === null || params === void 0 ? void 0 : params.client_code,
        },
        baseURL: getEnvSettings().adminApiUrl,
    });
};
export const updateOperationSettings = (params) => {
    return axios.patch('/operation_settings', params, {
        baseURL: getEnvSettings().adminApiUrl,
    });
};
